import React, { Component } from 'react';
import Grid from '../../Utils/GridFiltro';
import PropTypes from 'prop-types';
import { standardActions } from '../../Utils/Grid/StandardActions';
import { GrDocumentPdf } from 'react-icons/gr';
import { IconContext } from "react-icons";

class BodegasList extends Component{
    static propTypes = {
        data: PropTypes.object.isRequired,
        loader: PropTypes.bool.isRequired,
        reporteBodegas: PropTypes.func
    };

    static defaultProps = {
        loading: true
    };

    componentDidMount = () => {
        const { listar } = this.props;
        listar();
    }
    render(){
        const { data, loader, eliminar, reporteBodegas } = this.props;
        const estilo1 = {
            backgroundColor: "#ff413d", maxHeight: "35px", maxWidth: "35px"
        };
        let ruta = window.location.href;
        let id_emp = ruta.split('/');
        return(
            <React.Fragment>
                <br />
                <h3 className="p-2 bg-secondary title">Bodegas</h3>
                <br />
                <div className="d-flex flex-row justify-content-between mb-2">
                    <a
                        href={`/#/inventario/${id_emp[5]}/bodegas/crear`}
                        className='btn btn-primary' 
                    >
                        Crear Bodega
                    </a>
                    <button className='btn btn-dark float-right d-flex justify-content-center' onClick={reporteBodegas} style={estilo1}
                        data-bs-toggle="tooltip" data-bs-placement="left" title="Generar reporte">
                            <i>
                                <IconContext.Provider value={{size: "1.25rem" }}>
                                    <GrDocumentPdf/>
                                </IconContext.Provider>
                            </i>
                    </button>
                </div>
                {data &&
                    <Grid 
                        hover 
                        striped 
                        data={data} 
                        loading={loader} 
                        headerStyle={ { background: 'black' } } 
                        //onPageChange={onPageChange}
                        //onSortChange={onSortChange} 
                    >
                        <TableHeaderColumn
                            isKey
                            dataField="numero"
                            dataAlign='center'
                            dataSort
                            thStyle={
                                {color: 'white'}}
                            tdStyle={
                                {color: 'white'}}
                        >
                            Numero Bodega
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="bodega"
                            headerAlign="center"
                            dataAlign='left'
                            dataSort
                            thStyle={
                                {color: 'white'}}
                            tdStyle={
                                {color: 'white'}}
                        >
                            Bodega
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            thStyle={
                            {color: 'white'}}
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            dataFormat={standardActions({ 
                                editar: "bodegas", 
                                ver: "bodegas",
                            })} 
                            
                        >
                            Acciones
                        </TableHeaderColumn>
                    </Grid>
                }
            </React.Fragment>
        );
    }
}

export default BodegasList;
